import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {
  AddNewCallDiv,
  CallBtn,
  BlueAvatarDiv,
  HeadProfileBar,
} from '../styles/dialpadstyle'

export class CallBackNotifyTheme extends Component {
  render() {
    const {
      name,
      number,
      notification,
      profileImg,
      onClickAcceptBtn,
      acceptBtn,
      acceptText,
      onClickDeclineBtn,
      declineBtn,
      declineText
    } = this.props;
    return (
      <AddNewCallDiv className='d-flex flex-column justify-content-around' style={{height: 360}}>
        <HeadProfileBar>
          <BlueAvatarDiv>
            <img src={profileImg} />
          </BlueAvatarDiv>
          <h4>{name}</h4>
          <span className='number'>{number}</span>
          <p>{notification}</p>
        </HeadProfileBar>
        <CallBtn>
          <div>
            <i className="cursorPointer accept-i" onClick={onClickAcceptBtn}>
              <img src={acceptBtn} />
            </i>
            <span>{acceptText}</span>
          </div>
          <div>
            <i className="cursorPointer reject-i" onClick={onClickDeclineBtn}>
              <img src={declineBtn} />
            </i>
            <span>{declineText}</span>
          </div>
        </CallBtn>
      </AddNewCallDiv>
    )
  }
}


CallBackNotifyTheme.contextTypes = {
  __: PropTypes.func
};

export default CallBackNotifyTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CallBackNotifyTheme.js